import React from "react";
import CustomFormRenderer from "./components/custom-form-renderer.component";
import { CustomFormData } from "./types";
import { ExtendedFormTemplate } from "@/dentlab/src/pages/form-builder/types/formTypes";
import { usePostHog } from "posthog-js/react";
import { useCentralStore } from "../../store/Central";
import { Button } from "@/dentlab/src/components/ui/button";
import { Loader2 } from "lucide-react";

interface FormRendererProps {
	customForm?: ExtendedFormTemplate;
	customFormData?: CustomFormData;
	onCustomFormDataChange?: (data: CustomFormData) => void;
	loading?: boolean;
	onSubmit: () => void;
	onReset: () => void;
}

export const FormRenderer: React.FC<FormRendererProps> = ({
	customForm,
	customFormData = {},
	onCustomFormDataChange = () => {},
	loading = false,
	onSubmit,
	onReset,
}) => {
	const postHog = usePostHog();

	return (
		<form
			onSubmit={(e) => {
				e.preventDefault();
				postHog.capture("submit_job_request", {
					form_type: "custom",
				});
				postHog.capture("job_request_sent", {
					form_type: customForm ? "custom" : "standard",
					has_files: Object.values(customFormData).some(
						(f) =>
							f.fieldType === "file" &&
							Array.isArray(f.fieldValue) &&
							f.fieldValue.length > 0
					),
					source_app: "dentconnect",
				});
				const orgId = useCentralStore.getState().organization?.id;
				if (orgId) {
					postHog.group("organization", orgId, {
						$set_once: { first_job_request_sent_at: new Date().toISOString() },
					});
				}
				onSubmit();
			}}
			className="flex flex-col gap-4"
		>
			{customForm ? (
				<CustomFormRenderer
					form={customForm}
					formData={customFormData}
					onFormDataChange={onCustomFormDataChange}
				/>
			) : (
				<div className="p-6 bg-blue-50 rounded-lg border border-gray-200 w-full max-w-[640px] mx-auto">
					<p className="text-gray-500">
						Bitte wählen Sie ein Formular aus
					</p>
				</div>
			)}

			<div className="mt-4 mb-6 flex justify-between w-full max-w-[640px] mx-auto">
				<Button variant="outline" onClick={onReset} type="button">
					Formular zurücksetzen
				</Button>

				<Button
					disabled={loading || !customForm}
					type="submit"
					data-testid="job-request-submit-button"
					aria-label="Auftrag erstellen"
				>
					{loading ? (
						<>
							<Loader2 className="mr-2 h-4 w-4 animate-spin" />
							Wird erstellt...
						</>
					) : (
						"Auftrag erstellen"
					)}
				</Button>
			</div>
		</form>
	);
};
